const es = {
    'permissiongroup.table.button.create': 'Crear grupo de permisos',
    'permissiongroup.table.filter_by_sku': 'Filtrar por SKU',
    'permissiongroup.table.filter_by_description': 'Filtrar por Descripción',
    'permissiongroup.table.filter_by_deleted': 'Filtrar por Eliminado',
    'permissiongroup.table.filter_by_deleted_deleted': 'Elimandos',
    'permissiongroup.table.filter_by_deleted_not_deleted': 'No Eliminados',
    'permissiongroup.table.filter_by_deleted_all': 'Todos',
    'permissiongroup.table.title': 'Grupo de permisos',
    'permissiongroup.table.sku': 'SKU',
    'permissiongroup.table.description': 'Descripción',
    'permissiongroup.table.actions': 'Acciones',
    'permissiongroup.table.modal.delete.title': 'Eliminar',
    'permissiongroup.table.modal.delete.done': 'Realizado con éxito',
    'permissiongroup.table.modal.delete.phrase': '¿Estás seguro de que quieres eliminar?',
    'permissiongroup.table.modal.delete.button.cancel': 'Cancelar',
    'permissiongroup.table.modal.delete.button.delete': 'Eliminar',
    'permissiongroup.table.modal.restore.title': 'Restaurar',
    'permissiongroup.table.modal.restore.done': 'Realizado con éxito',
    'permissiongroup.table.modal.restore.phrase': '¿Estás seguro de que quieres restaurar?',
    'permissiongroup.table.modal.restore.button.cancel': 'Cancelar',
    'permissiongroup.table.modal.restore.button.restore': 'Restaurar',

    'permissiongroup.form.permissions_not_found': 'No se encontraron permisos',
    'permissiongroup.form.permissions': 'Permisos',
    'permissiongroup.form.update': 'Actualizar grupo',
    'permissiongroup.form.create': 'Crear grupo',
    'permissiongroup.form.sku': 'SKU',
    'permissiongroup.form.description': 'Descripción',
    'permissiongroup.form.cancel': 'Volver',
};

export default es;